export const toSlug = (text: string): string =>
  text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const clubPath = (club: { id: number; name: string }): string =>
  `/club/${club.id}-${toSlug(club.name)}`;

export const playerPath = (player: { id: number; first_name: string; last_name: string }): string =>
  `/player/${player.id}-${toSlug(`${player.first_name} ${player.last_name}`)}`;

export const idFromSlug = (slug: string): number =>
  parseInt(slug, 10) || 0;
